import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useStyles } from '../../../styles/mapStylesCustom';
import ManageComponents from '../ManageComponents';

const RenderGridv3 = props => {
  const { changeLoading, child, isPublicMap, MapProps, map } = props;
  const classes = useStyles();
  const hasChildren = child && child.length;
  return (
    <div>
      {hasChildren &&
        child.map(item => (
          <div key={item.id}>
            {item.child ? (
              <RenderGridv3 key={item.id} {...item} />
            ) : (
              <Box className={classes.root} padding="0px" height="0px">
                <ManageComponents
                  MapProps={MapProps}
                  map={map}
                  id={item.id}
                  name={item.name}
                  color={item.color}
                  componente={item.componente}
                  arriba={item.arriba}
                  height={item.height}
                  arribasize={item.arribasize}
                  izquierda={item.izquierda}
                  centro={item.width}
                  isPublicMap={isPublicMap}
                  changeLoading={changeLoading}
                />
              </Box>
            )}
          </div>
        ))}
    </div>
  );
};

RenderGridv3.defaultProps = {
  changeLoading: () => {},
  isPublicMap: false,
  map: {},
  MapProps: {}
};

RenderGridv3.propTypes = {
  changeLoading: PropTypes.func,
  child: PropTypes.array.isRequired,
  isPublicMap: PropTypes.bool,
  map: PropTypes.object,
  MapProps: PropTypes.object
};

export default RenderGridv3;
